import React from "react";
import { observer, inject } from "mobx-react";
import * as M from "@material-ui/core";
import * as yup from "yup";
import { Formik, Field, Form } from "formik";

let validationSchema = yup.object().shape({
  email: yup.string().required("Dit veld is verplicht").email("Foutieve emailnotatie"),
  password: yup.string().required("Dit veld is verplicht")
});

const UserSignIn = ({ store }) => {
  const { $user, $locale } = store;
  return (
    <M.Dialog open={$user.enableSignIn} onClose={() => $user.change("enableSignIn", false)}>
      <Formik
        initialValues={{
          email: "",
          password: ""
        }}
        validationSchema={validationSchema}
        onSubmit={async (data, { setSubmitting }) => {
          setSubmitting(true);
          $user.signIn(data.email, data.password);
        }}
      >
        {({ values, errors, touched, isSubmitting, handleChange }) => (
          <Form name="user-siginin" className="w-full" noValidate>
            <M.DialogTitle>{$locale.t("user_signin") || "Aanmelden"}</M.DialogTitle>
            <M.DialogContent>
              <M.Box my={2}>
                <Field
                  error={!!(touched.email && errors.email)}
                  fullWidth
                  label={$locale.t("email") || "E-mail"}
                  name="email"
                  type="email"
                  required
                  helperText={touched.email && errors.email}
                  as={M.TextField}
                />
                <Field
                  error={!!(touched.password && errors.password)}
                  fullWidth
                  label={$locale.t("password") || "Wachtwoord"}
                  type="password"
                  name="password"
                  required
                  helperText={touched.password && errors.password}
                  as={M.TextField}
                />
              </M.Box>
            </M.DialogContent>
            <M.DialogActions>
              <M.Button
                variant="outlined"
                onClick={e => {
                  if (!$user.sessionUser.uid) {
                    $user.change("enableSignIn", false);
                    $user.change("enablePasswordReset", true);
                  }
                }}
              >
                {$locale.t("user_password_reset_title")}
              </M.Button>
              <React.Fragment>
                <M.Button variant="outlined" onClick={() => $user.change("enableSignIn", false)}>
                  {$locale.t("cancel") || "Annuleren"}
                </M.Button>
                <M.Button type="submit">{$locale.t("user_signin") || "inloggen"}</M.Button>
              </React.Fragment>
            </M.DialogActions>
          </Form>
        )}
      </Formik>
    </M.Dialog>
  );
};

export default inject("store")(observer(UserSignIn));
